import { UploadedFileViewModel } from '../../../file-upload/components/file-upload.view-model';
import { ViewModelCommon } from '../view-model-common/view-model-common';
import { PartialProgram } from '../../../domain/program';
import { SchedulingControlViewModel } from '../scheduling-control/scheduling-control-view-model';
import { LayoutObjectApiModel } from '@cxb/editor-stb-api';
import { TrayFormViewModelType } from '../view-model-common/view-model-type';
import { SeasonPageItemApiModel } from '@cxb/editor-stb-api/model/models';
import { LocalizedFormData } from '../../common/localized-form-data';

export enum SinglePhotoSeasonTraySortViewModel {
  Ascending = 'Ascending',
  Descending = 'Descending',
}

export interface SinglePhotoSeasonTrayFormViewModel extends ViewModelCommon {
  id: string;
  title: LocalizedFormData<string>;
  description: LocalizedFormData<string>;
  userSegmentIds: string[];
  platformIds: string[];
  countryIds: string[];
  type: TrayFormViewModelType.SinglePhotoSeasonTray;
  scheduling: SchedulingControlViewModel;
  image: UploadedFileViewModel;
  sort: SinglePhotoSeasonTraySortViewModel;
  program: PartialProgram;
  layout: LayoutObjectApiModel;
  displayServiceTypeIcon: boolean;
}

export interface SeasonPageItemWithProgramApiModel extends SeasonPageItemApiModel {
  program?: PartialProgram;
}
